module.exports = __webpack_public_path__ + "static/media/bt.2bc8f9b3.svg";